import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { TriggerGraph } from "./types";

export function deriveGraph(source: string, filename = "<trigger>"): Promise<TriggerGraph> {
  return api.post<TriggerGraph>("/graph", { source, filename });
}

function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

/** Graph for the editor's current text, re-derived (debounced) as the user types. */
export function useTriggerGraph(source: string, filename: string, debounceMs = 350) {
  const debounced = useDebounced(source, debounceMs);
  return useQuery({
    queryKey: ["graph", filename, debounced],
    queryFn: () => deriveGraph(debounced, filename),
    placeholderData: (prev) => prev,
    staleTime: Infinity,
    retry: false,
  });
}
